import axios from "axios";
import { API_URL } from '../api.js'

const api = `${API_URL}/transaction`

export default {
  async getTransactions(restaurantId) {
    const resp = await axios.get(`${api}/${restaurantId}`);
    return resp.data;
  }
};
